import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { MAILING_SETTINGS_SENDER_EMAILS_API } from '../api/mailing-settings-sender-emails-api';
import { ReplaceSenderEmailAddressInterface, SenderEmailAddressId } from '../types/sender-email-address-interface';
export const useSenderEmailAddressActions = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = async (id, email) => fetcher(`${MAILING_SETTINGS_SENDER_EMAILS_API}/${id}`, {
      senderEmailAddress: email
    });
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const replaceEmail = t1;
  let t2;
  if ($[3] !== isFetching || $[4] !== replaceEmail) {
    t2 = {
      replaceEmail,
      isFetching
    };
    $[3] = isFetching;
    $[4] = replaceEmail;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};